import React from 'react'
import './offers.css'
import {BsCalendarCheck, BsPinMap, BsWifi} from 'react-icons/bs'
import {MdOutlineDesignServices} from 'react-icons/md'
import {IoPricetagsOutline, IoAccessibilityOutline} from 'react-icons/io5'
import {GiHomeGarage, GiTabletopPlayers} from 'react-icons/gi'

const Offers = () => {
  return (
    <section className='offers'>
        <div className="offers-header">
            <span>WHAT WE OFFER</span>
            <h2>Why guests choose Luxistt</h2>
        </div>
        <div className="offers-list">
            <div className="c-block">
                <BsCalendarCheck color='#127872' fontSize="35px"/>
                <h5>Fast &amp; easy booking</h5>
                <div className="line"></div>
                <p>Pick dates, see real-time availability, and confirm your stay online — no endless back-and-forth.</p>
            </div>
            <div className="c-block">
                <IoPricetagsOutline color='#127872' fontSize="35px"/>
                <h5>Fair, transparent pricing</h5>
                <div className="line"></div>
                <p>Affordable nightly rates with clarity on what you pay, so you can plan short trips without surprises.</p>
            </div>
            <div className="c-block">
                <MdOutlineDesignServices color='#127872' fontSize="35px"/>
                <h5>Thoughtfully furnished spaces</h5>
                <div className="line"></div>
                <p>Apartments set up for real living — comfortable furniture, usable layouts, and the essentials in place.</p>
            </div>
            <div className="c-block">
                <BsPinMap color='#127872' fontSize="35px"/>
                <h5>Prime &amp; practical locations</h5>
                <div className="line"></div>
                <p>Stays in neighbourhoods that work for business, family visits, and exploring the city.</p>
            </div>
            <div className="c-block">
                <GiTabletopPlayers color='#127872' fontSize="35px"/>
                <h5>Outdoor &amp; lounge areas</h5>
                <div className="line"></div>
                <p>Many Luxistt apartments include balconies, sit-outs, or shared spaces to relax outside your unit.</p>
            </div>
            <div className="c-block">
                <BsWifi color='#127872' fontSize="35px"/>
                <h5>Reliable Wi‑Fi</h5>
                <div className="line"></div>
                <p>Stay connected for remote work, video calls, and planning your next move.</p>
            </div>
            <div className="c-block">
                <IoAccessibilityOutline color='#127872' fontSize="35px"/>
                <h5>A full Luxistt apartment to yourself</h5>
                <div className="line"></div>
                <p>Private short-let units with space to cook, rest, and entertain — not just a single hotel room.</p>
            </div>
            <div className="c-block">
                <GiHomeGarage color='#127872' fontSize="35px"/>
                <h5>Parking where available</h5>
                <div className="line"></div>
                <p>Selected Luxistt apartments offer parking or easy access for drivers — check each property for details.</p>
            </div>
        </div>
    </section>
  )
}

export default Offers